import type { ChipProps } from "@exopengithub/exokit";
import type {
	DomainPlan,
	ModuleRefType,
	PlanCopyOptions,
	PlanCopyOptionsByRefType,
} from "@exopengithub/planning-api-shared";
import type { TFunction } from "i18next";

export const mapPlanStatus = (
	planStatus: DomainPlan["status"],
	t: TFunction,
): { text: string; color: ChipProps["variant"] } => {
	switch (planStatus) {
		case "done":
			return { text: t("Done"), color: "purple" };
		case "in_progress":
			return { text: t("In progress"), color: "purple" };
		case "approved":
			return { text: t("Approved"), color: "primary" };
		default:
			throw new Error("Unknown plan status");
	}
};

export const isPlanReadOnly = (status: DomainPlan["status"]) => {
	switch (status) {
		case "approved":
		case "done":
			return true;
		case "in_progress":
			return false;
	}
};

export const selectModuleCopyOptions = (
	plan: DomainPlan,
	copyOptions: PlanCopyOptionsByRefType,
) => {
	return plan.modules.reduce(
		(acc, module) => {
			const moduleCopyOptions: PlanCopyOptions<string> =
				copyOptions[module.refType];

			if (moduleCopyOptions) {
				const keys = Object.keys(moduleCopyOptions);
				if (keys.length === 1) {
					acc[module.refType] = keys[0];
				} else {
					for (const [key, value] of Object.entries(moduleCopyOptions)) {
						if (value.isDefault) {
							acc[module.refType] = key;
							break;
						}
					}
				}
			}

			return acc;
		},
		{} as Partial<Record<ModuleRefType, string>>,
	);
};

export const plansInScope = (
	plans: DomainPlan[],
	legalEntityId: string | undefined,
) =>
	legalEntityId
		? plans.filter((plan) => plan.nexusLegalEntityId === legalEntityId)
		: plans;
